import { GODEX_PRINTER_HINTS } from '../config_and_helpers/labelPrinterConfig';

/**
 * Score a printer name against GoDEX hint substrings.
 * @param {string} printerName
 * @returns {number}
 */
export const scorePrinterName = printerName => {
  const lower = String(printerName || '').toLowerCase();
  let score = 0;
  GODEX_PRINTER_HINTS.forEach(hint => {
    if (lower.includes(hint.toLowerCase())) score += 1;
  });
  return score;
};

/**
 * Sort printers by hint score (desc), then alphabetically.
 * @param {string[]} printers
 * @returns {string[]}
 */
export const sortPrintersByHint = printers =>
  [...(printers || [])].sort((a, b) => {
    const diff = scorePrinterName(b) - scorePrinterName(a);
    if (diff !== 0) return diff;
    return a.localeCompare(b);
  });

/**
 * Return the sole auto-match when exactly one printer scores above zero.
 * @param {string[]} printers
 * @returns {string|null}
 */
export const findAutoMatchedPrinter = printers => {
  const matches = (printers || []).filter(p => scorePrinterName(p) > 0);
  if (matches.length === 1) return matches[0];
  return null;
};

/**
 * @param {string[]} printers
 * @param {string|null} savedName
 * @returns {string|null}
 */
export const resolvePrinterName = (printers, savedName) => {
  const list = printers || [];
  if (savedName && list.includes(savedName)) return savedName;
  return findAutoMatchedPrinter(list);
};
